// extracted by mini-css-extract-plugin
module.exports = {"socialSignup":"social-login_socialSignup_nvOdE","buttonSocial":"social-login_buttonSocial_1ITnn"};